<template>
  <div>
   
    <InnerMenuQuality />
  </div>
</template>

<script>
import InnerMenuQuality from "@/components/quality/InnerMenuQuality.vue";

export default {
  components: {
    InnerMenuQuality,
  },
};
</script>
<style scoped>
.app-container {
  display: flex;
  height: 100vh; /* Esto hace que el componente ocupe todo el espacio vertical */
}
</style>
